const personas = [
  {
    tag: '保險知音',
    tagSub: '懂你心的傾聽者',
    icon: 'ri-chat-smile-3-line',
    accentColor: '#FF8C69',
    title: '先聽懂您，再談保障',
    points: [
      '擅長傾聽與共情，從您的故事找到真正需求',
      '理性分析 × 感性理解，協助您在情緒與現實間取得平衡',
      '像朋友一樣陪伴，不急著成交',
    ],
    quote: '我不急著賣您保險，我想先知道，您最近過得好不好？',
    bg: 'bg-white',
    border: 'border-[#FF8C69]/25',
  },
  {
    tag: '保險暖男',
    tagSub: '用行動守護的人',
    icon: 'ri-hand-heart-line',
    accentColor: '#5C5470',
    title: '把在乎，做成具體的保障',
    points: [
      '誠懇、有責任感與行動力，默默完成承諾',
      '不做浮誇承諾，只做實在守護',
      '用溫柔與幽默，讓複雜的事變簡單',
    ],
    quote: '您不一定懂保險，但您會感受到我的在乎。',
    bg: 'bg-[#5C5470]',
    border: 'border-[#5C5470]',
    dark: true,
  },
  {
    tag: '保險建築師',
    tagSub: '為人生設計安全藍圖',
    icon: 'ri-building-2-line',
    accentColor: '#D4A373',
    title: '結構化的風險設計',
    points: [
      '把風險視為藍圖的一部分，先搭好屋頂再迎風雨',
      '整合醫療、意外、重大疾病、收入保障與資產防護',
      '用數據與邏輯，打造可長住的安心建築',
    ],
    quote: '每一張保單，都是為您築起的安全屋。',
    bg: 'bg-[#F8F5F0]',
    border: 'border-[#D4A373]/25',
  },
];

export default function AboutPersona() {
  return (
    <section className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            WHO I AM
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            品牌人格三面向
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {personas.map((p) => (
            <div
              key={p.tag}
              className={`${p.bg} border ${p.border} rounded-3xl p-8 flex flex-col hover:-translate-y-1 transition-transform duration-300`}
            >
              {/* Icon + Tag */}
              <div className="flex items-center gap-3 mb-6">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ backgroundColor: `${p.accentColor}20` }}
                >
                  <i className={`${p.icon} text-2xl`} style={{ color: p.accentColor }}></i>
                </div>
                <div>
                  <div
                    className="font-bold"
                    style={{ fontSize: '1.0625rem', color: p.accentColor }}
                  >
                    {p.tag}
                  </div>
                  <div
                    className={p.dark ? 'text-white/60' : 'text-gray-500'}
                    style={{ fontSize: '1rem' }}
                  >
                    {p.tagSub}
                  </div>
                </div>
              </div>

              {/* Title */}
              <h3
                className={`font-serif font-bold mb-5 ${p.dark ? 'text-white' : 'text-[#5C5470]'}`}
                style={{ fontSize: 'clamp(1.25rem, 1.8vw, 1.625rem)', lineHeight: '1.45' }}
              >
                {p.title}
              </h3>

              {/* Points */}
              <ul className="space-y-3 mb-8 flex-1">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-2.5">
                    <span
                      className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ backgroundColor: p.accentColor }}
                    ></span>
                    <span
                      className={p.dark ? 'text-white/80' : 'text-gray-600'}
                      style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}
                    >
                      {pt}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Quote */}
              <div
                className="rounded-xl p-5 mt-auto"
                style={{ backgroundColor: `${p.accentColor}15` }}
              >
                <i
                  className="ri-double-quotes-l text-3xl block mb-2"
                  style={{ color: `${p.accentColor}60` }}
                ></i>
                <p
                  className={`italic ${p.dark ? 'text-white/90' : 'text-[#5C5470]'}`}
                  style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}
                >
                  {p.quote}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
